import { internalAxios } from '../../utils/axios/internal';

// eslint-disable-next-line import/prefer-default-export
export const send = async (data = {}) => {
  const response = await internalAxios.post('/api/auctioneers/contact/send_email', data);
  return response.data;
};
